import {FETCH_REGULATORY_COUNTRY} from "../../actions/actionTypes"

const initialState = {  
    data: {},
    loading: false,
};

const reducer = (state = initialState, action) => {
    
    switch (action.type) {    
        case FETCH_REGULATORY_COUNTRY.REQUEST:
            return {...state,loading: true}
        case FETCH_REGULATORY_COUNTRY.FAILURE:
            return {...state, loading: false}
        case FETCH_REGULATORY_COUNTRY.SUCCESS:             
            return {...state, data: action.obj, loading: false}    
        default:
            return state
    }
}

export default reducer;